{
  "#WIEGUNG": {
    "TITLE": "Wiegung",
    "SELECT_ACTION": "Aktion auswählen",
    "MATERIAL_DELIVERY_NOTE": "Materiallieferschein",
    "MATERIAL_DELIVERY_NOTE_RETOUR": "Retourschein",
    "INTERMEDIATE_WEIGHING": "Zwischenwiegen",
    "INVENTORY": "Inventur",
    "WHOLE": "Gesamtwiegen",
    "TITLES": {
      "ERSTWIEGUNG": "Erstwiegung",
      "MATERIALLIEFERSCHEIN": "Materiallieferschein",
      "MATERIALLIEFERSCHEIN_RETOUR": "Retourschein (Material)",
      "ZWISCHENWIEGEN": "Zwischenwiegen",
      "INVENTUR": "Inventur",
      "GESAMTWIEGEN": "Gesamtwiegen"
    },
    "SCAN": "Scan",
    "LABELS": {
      "RESPONSIBLE": "Zuständiger",
      "LAGER": "Lager",
      "SCAN_ORDER_NUMBER": "Auftragsnummer scannen oder manuell eingeben",
      "SCAN_MATERIAL": "Material scannen oder manuell eingeben",
      "USER": "Anwender",
      "WAREHOUSE": "Goldschmied (Lager)",
      "ORDER_NUMBER": "Auftragsnummer",
      "CUSTOMER": "Kunde",
      "BRANCH": "Filiale",
      "WEIGH": "Wiegen",
      "ORDER_NUMBER_PLACEHOLDER": "Auftragsnummer eingeben",
      "MATERIAL_PLACEHOLDER": "Material auswählen"
    },
    "MESSAGES": {
      "WEIGH_SUCCESS_TITLE": "Erfolgreich",
      "WEIGH_SUCCESS_BODY": "Es wurden {{weight}} Gramm gewogen",
      "WEIGH_ERROR_TITLE": "Fehler",
      "WEIGH_ERROR_BODY": "Der Artikel konnte nicht gewogen werden!",
      "NO_SCALE_TITLE": "Keine Waage hinterlegt",
      "NO_SCALE_MESSAGE": "Bitte hinterlegen Sie die Waage in den Einstellungen!"
    }
  }
}
